import type { ClientDiscountRootOwner } from '../vendorTerms/types';
import type { ClientTargetPath } from './types';

export type ClientDiscountOwner = {
  kind: 'vendor' | 'service-category';
  id: number;
  name: string;
  rootPath: ClientTargetPath;
  discoveryFilter: {
    kind: 'MEDIA' | 'SERVICE';
    outlet_or_service_category?: number;
    outlet_or_service_category__vendor?: number;
  };
  targetHint: string;
};

/** Normalize the persisted owner once at the section boundary. */
export function clientDiscountOwner(owner: ClientDiscountRootOwner): ClientDiscountOwner {
  const { id, label: name } = owner;
  if (owner.kind === 'vendor') {
    return {
      kind: 'vendor',
      id,
      name,
      rootPath: [{ kind: 'vendor', id, label: name }],
      discoveryFilter: { kind: 'MEDIA', outlet_or_service_category__vendor: id },
      targetHint: `Vendor: ${name}. Choose the vendor, an outlet, or a media product.`,
    };
  } else {
    const { type } = owner;
    return {
      kind: 'service-category',
      id,
      name,
      rootPath: [{ kind: 'service-category', id, label: name, type }],
      discoveryFilter: { kind: 'SERVICE', outlet_or_service_category: id },
      targetHint: `Service category: ${name}. Choose the category or a service product.`,
    };
  }
}

export function targetBelongsToOwner(path: ClientTargetPath, owner: ClientDiscountOwner): boolean {
  const root = path[0];
  return root.kind === owner.kind && root.id === owner.id;
}
